import { render } from "./AppDownloadModal.vue?vue&type=template&id=60bc3afb&scoped=true&ts=true&lang=pug"
import script from "./AppDownloadModal.vue?vue&type=script&lang=ts"
export * from "./AppDownloadModal.vue?vue&type=script&lang=ts"

import "./AppDownloadModal.vue?vue&type=style&index=0&id=60bc3afb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bc3afb"]])

export default __exports__